import React, { useCallback, useEffect, useRef, useState } from "react";
//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Checkbox, FormHelperText, FormLabel, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { Card, Container } from "reactstrap";
import AppDialog from "../../components/Common/AppDialog";
import DeleteModal from "../../components/Common/DeleteModal";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import CustomSelectMultiple from "../../components/Form/CustomSelectMultiple";
import CustomSelectMultiple2 from "../../components/Form/CustomSelectMultiple2";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import Helpers from "../../helpers/helpers";
import { approveRejectProduct, bulkAttachPdf, deleteBulkProduct, deleteProduct, exportProduct, getGeneral, getProductListing, importProduct, importProductImage, preAddData, resetImportState, resetProductState } from "../../store/actions.js";
import ProductFilterContent from "./ProductFilterContent";
import ApproveModal from "./Services/ApproveModal.js";
import RejectModal from "./Services/RejectModal.js";

const Products = ({ title, delProductArry, exportExcel, product, categoryListing, delBulkProductArry, modelListing, manufactureListing, approveRejectProductState, userPermission, importExcelData, importImageData, bulkAttachPdfState }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setIsLoading] = useState(false);
  const [rejectModal, setRejectMOdal] = useState(false)
  const [approveModal, setApproveMOdal] = useState(false)
  const [selectedRow, setSelectedRow] = useState([])
  const [error, setError] = useState(false);
  const [approveRejectValue, setApproveRejectValue] = useState({
    product_id: "",
    creation_status: "",
    is_ariba_product: "",
    is_aspeed_product: "",
    reject_reason: ""
  });
  const [page, setPage] = useState("1");
  const [checkedAll, setCheckedAll] = useState(false);
  const [length, setLength] = useState("50");
  const [name, setSearch] = useState("");
  const searchRef = useRef(name);
  const [sort, setSorted] = useState("desc")
  const [sort_by, setSortBy] = useState("id")
  const [open, SetOpen] = useState(false);
  const [openDel, SetOpenDel] = useState(false);
  const [platformData, setPlatformData] = useState([
    { name: "is_ariba_product", label: "Ariba Punchout E-commerce Platform", state: false },
    { name: "is_aspeed_product", label: "Aspeed E-commerce Platform", state: false },
  ])
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const [importable, setImportable] = useState(false);
  const [approveable, setApproveable] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [bulkPdfModalOpen, setBulkPdfModalOpen] = useState(false);
  const [bulkPdfFile, setBulkPdfFile] = useState(null);
  const [bulkPdfError, setBulkPdfError] = useState("");

  useEffect(() => {
    dispatch(resetProductState())
    dispatch(getGeneral())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-product") && setCreatable(true);
      userPermission?.includes("edit-product") && setEditable(true);
      userPermission?.includes("delete-product") && setDeletable(true);
      userPermission?.includes("export-product") && setExportable(true);
      userPermission?.includes("export-product") && setImportable(true);
      userPermission?.includes("approve-product") && setApproveable(true);
      !userPermission?.includes("view-product") && navigate('/not-authorized');
    }
  }, [userPermission])

  const [formValues, setFormValues] = useState({
    type: "simple",
    manufacturer: "",
    model: "",
    categories: [],
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [filterObject, setFilterObject] = useState({
    status: "all",
    type: "0",
    platform: "0"
  });

  const [content, setContent] = useState({
    open: false,
    title: "",
    msg: "",
    buttonTitle: "",
    action: "",
    id: "",
  })

  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });


  const platformList = [
    { value: "0", label: "All platforms" },
    { value: "aspeed", label: "Aspeed" },
    { value: "ariba", label: "Ariba" },
  ]

  const productTypesList = [
    { value: "0", label: "All types" },
    { value: "simple", label: "Simple" },
    { value: "configurable", label: "Configurable" },
    { value: "variant", label: "Variant" },
  ]

  useEffect(() => {
    searchRef.current = name || '';
  }, [name]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, length, sort, sort_by, filterObject]);

  useEffect(() => {
    if (exportExcel?.code === "success") {
      setIsLoading(false)
      Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'Product');
      dispatch(resetProductState());
      setSelectedRow("");
      setCheckedAll(false);
      initData();
    }

  }, [exportExcel]);

  useEffect(() => {
    if (importExcelData?.code === "success") {
      setIsLoading(false)
      dispatch(resetProductState());
      setNotification({
        open: true,
        msg: "Products imported successfully",
        type: "success"
      })
      dispatch(getGeneral())
      initData();
    } else if (importExcelData?.code === "error") {
      setIsLoading(false)
      setNotification({
        open: true,
        msg: importExcelData?.message,
        type: "error"
      })
      dispatch(resetImportState())
    }

  }, [importExcelData]);

  useEffect(() => {
    if (importImageData?.code === "success") {
      setIsLoading(false)
      dispatch(resetProductState());
      setNotification({
        open: true,
        msg: importImageData?.message || "Images imported successfully",
        type: "success"
      })
      setPopUpOpen(false);
      dispatch(getGeneral())
      dispatch(resetImportState())
      setProductImages([]);
      initData();
    } else if (importImageData?.code === "error" || importImageData?.code === false) {
      setIsLoading(false)
      setNotification({
        open: true,
        msg: importImageData?.message || importImageData?.errors?.upload || "Failed to import images",
        type: "error"
      })
      dispatch(resetImportState())
    }

  }, [importImageData]);

  useEffect(() => {
    if (bulkAttachPdfState?.code === "success") {
      setIsLoading(false);
      const failed = bulkAttachPdfState?.data?.failed || [];
      const succeeded = bulkAttachPdfState?.data?.succeeded || [];
      setNotification({
        open: true,
        msg: failed.length > 0
          ? `Attached to ${succeeded.length} product(s). Failed for IDs: ${failed.map(f => f.id).join(", ")}`
          : `PDF attached to ${succeeded.length} product(s) successfully`,
        type: failed.length > 0 ? "warning" : "success",
      });
      setBulkPdfModalOpen(false);
      setBulkPdfFile(null);
      setBulkPdfError("");
      setSelectedRow("");
      setCheckedAll(false);
      dispatch(resetImportState());
    } else if (bulkAttachPdfState?.code && bulkAttachPdfState?.code !== "success" && !Array.isArray(bulkAttachPdfState)) {
      setIsLoading(false);
      setNotification({
        open: true,
        msg: bulkAttachPdfState?.message || "Failed to attach PDF.",
        type: "error",
      });
      dispatch(resetImportState());
    }
  }, [bulkAttachPdfState]);

  useEffect(() => {
    if (approveRejectProductState?.code === "success") {
      setNotification({
        open: true,
        msg: "Update Successfully",
        type: "success",
      })
      setApproveMOdal(false);
      setRejectMOdal(false);
      setApproveRejectValue("");
      initData();
      dispatch(getGeneral());
      dispatch(resetProductState());
      initData()
    }

  }, [approveRejectProductState]);

  useEffect(() => {
    setApproveRejectValue((prevValues) => ({
      ...prevValues,
      is_ariba_product: platformData?.[0]?.state ? 1 : 0,
      is_aspeed_product: platformData?.[1]?.state ? 1 : 0,
    }))
  }, [platformData]);

  useEffect(() => {
    if (delProductArry?.code === "success") {
      setNotification({
        open: true,
        msg: "Delete Successfully",
        type: "success",
      });
      SetOpenDel(false);
      dispatch(resetProductState());
      initData();
      setSelectedRow("");
      dispatch(getGeneral());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delProductArry]);

  useEffect(() => {
    if (delBulkProductArry?.code === "success") {
      setNotification({
        open: true,
        msg: "Delete Successfully",
        type: "success",
      });
      SetOpenDel(false);
      dispatch(resetProductState());
      setSelectedRow("");
      setCheckedAll(false);
      dispatch(getGeneral());
      initData();
    } else if (delBulkProductArry?.code === "error" || delProductArry?.code === "failed" || delBulkProductArry?.code === "invalid_product") {
      setNotification({
        open: true,
        msg: delBulkProductArry?.message || "Failed to delete products.",
        type: "error",
      });
      dispatch(resetImportState());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delBulkProductArry]);

  useEffect(() => {
    if (checkedAll && product?.data) {
      const productListingIDs = product.data.map((item) => item.id);
      setSelectedRow(productListingIDs);
    } else if (!checkedAll && selectedRow.length === product?.data?.length) {
      // Only clear if all items were selected (meaning user clicked "uncheck all" header)
      setSelectedRow("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedAll, product?.data]);

  const initData = () => {
    dispatch(getProductListing({
      length: length,
      page: page,
      keyword: searchRef.current,
      sort: sort,
      sort_by: sort_by,
      status: filterObject?.status,
      product_type: filterObject?.type,
      sales_platform: filterObject?.platform,
      categories_id: filterObject?.category_id,
    }));
  }

  const getLengthPage = (page, length) => {
    setPage(page)
    setLength(length)
  }

  const resetFilter = () => {
    setPage("1");
    setFilterObject({ status: 'all', type: '0', platform: "0", category_id: [] });
    setSearch('');
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage("1");
        initData();
      }
    }, Helpers.searchInterval);
  }

  const setApproveRejectData = (type, data) => {
    setApproveRejectValue({
      product_id: data?.id,
      creation_status: type === "reject" ? "rejected" : "approved",
      is_ariba_product: data?.is_ariba_product,
      is_aspeed_product: data?.is_aspeed_product,
      reject_reason: data?.reject_reason,
    })
    if (type === "reject") {
      setRejectMOdal(true)
      // dispatch(approveRejectProduct({ product: approveRejectValue }))

    } else if (type === "approve") {
      setApproveMOdal(true)
      setPlatformData([
        { name: "is_ariba_product", label: "Ariba Punchout E-commerce Platform", state: data?.is_ariba_product === 1 ? true : false },
        { name: "is_aspeed_product", label: "Aspeed E-commerce Platform", state: data?.is_aspeed_product === 1 ? true : false },
      ])
      // dispatch(approveRejectProduct({ product: approveRejectValue }))

    }
  }

  const handleCheckboxChange = (e) => {
    setCheckedAll(false)
    let temp = []
    if (selectedRow && selectedRow.includes(parseInt(e))) {
      temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
      setSelectedRow(temp)
    } else {
      setSelectedRow([...selectedRow, parseInt(e)])
    }
  }

  const header = [
    {
      Header: "#",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Checkbox
              checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow?.includes(cellProps.id) : false}
              sx={{
                color: '#D0D0D0',
                '&.Mui-checked': {
                  color: "var(--bs-theme-color)",
                },
                paddingBlock: 0
              }}
              value={cellProps.id}
              onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
          </React.Fragment>
        )
      },
    },
    {
      Header: "Product",
      columnID: "product_name",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              <div style={{ paddingRight: "5px" }}>{cellProps.product_name}</div>
            </Stack>
          </React.Fragment>
        )
      },
      minWidth: 150,
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Type",
      columnID: "product_type",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              {Helpers.capitalize(cellProps.product_type)}
            </Stack>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Category",
      columnID: "category",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              {cellProps?.category_list || "-"}
            </Stack>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      columnID: "status",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              <Label.ProductStatusLabel label={cellProps?.status} marginLeft={"0px"} />
            </Stack>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Creation Status",
      columnID: "creation_status",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              {cellProps?.creation_status ? <Label.ProductStatusLabel label={cellProps.creation_status} marginLeft={'0px'} /> : '-'}
            </Stack>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Inventory",
      columnID: "quantity",
      accessor: (cellProps) => {
        return (
          <div style={{ color: cellProps?.inventory < 0 ? "red" : "" }}>{cellProps?.quantity || 0} in stock</div>
        )
      },
      minWidth: 100,
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Sales platform",
      columnID: "is_ariba_product",
      accessor: (cellProps) => {
        return (
          <div>{cellProps?.is_ariba_product === 1 && "Ariba"}{cellProps?.is_aspeed_product == 1 && cellProps?.is_ariba_product == 1 && ","} {cellProps?.is_aspeed_product == 1 && "Aspeed"} </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable &&
              <Link to={`/edit-product/` + (cellProps.id) + "/" + (cellProps.product_type)}>
                <CustomIconButton iconName={'ri-pencil-line'} onClick={() => ''} />
              </Link>}
            {(approveable || deletable) &&
              <>
                <RenderPopOverButton
                  approveable={approveable}
                  deletable={deletable}
                  items={[{
                    iconName: 'ri-delete-bin-line',
                    label: 'Delete',
                    color: '#ED1A3D',
                    permission: deletable,
                    onClick: () => { SetOpenDel(true); setSelectedRow(cellProps?.id) }
                  },
                  {
                    iconName: 'ri-check-line',
                    label: 'Approve',
                    color: '#28a745',
                    permission: approveable && cellProps?.status === 1 && (cellProps?.creation_status === "pending_approval" || cellProps?.creation_status === "rejected"),
                    onClick: () => setApproveRejectData("approve", cellProps),
                  },
                  {
                    iconName: 'ri-close-large-line',
                    label: 'Reject',
                    color: '#ED1A3D',
                    permission: approveable && cellProps?.status === 1 && cellProps?.creation_status === "pending_approval",
                    onClick: () => setApproveRejectData("reject", cellProps),
                  }]}
                // handleOpenPopover={(e) => handleOpenPopover(e, cellProps)} propsData={propsData} openPopover={openPopover} handleClosePopover={handleClosePopover}
                // onReject={(e) => setApproveRejectData("reject", propsData)}
                // onApprove={(e) => setApproveRejectData("approve", propsData)}
                // onDel={(e) => SetOpenDel(true)}
                />
              </>}

          </React.Fragment>
        )
      },
      minWidth: 120,
      position: 'sticky',
      disableFilters: true,
      filterable: false,
    }
  ]

  const handleExport = () => {
    let filter = {
      status: filterObject?.status === "all" ? "" : filterObject?.status,
      product_type: filterObject?.type === "0" ? "" : filterObject?.type,
      platform: filterObject?.platform === "0" ? "" : filterObject?.platform,
      search: name,
      category_id: filterObject?.category_id,
    }
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    if (selectedRow?.length > 0) {
      let ids = selectedRow?.map((x, idx) => x)
      dispatch(exportProduct({
        sort: sort_by,
        sort_order: sort,
        filter: filter,
        ids: ids
      }));
      setIsLoading(true);

    } else {
      dispatch(exportProduct({
        sort: sort_by,
        sort_order: sort,
        filter: filter
      }));
      setIsLoading(true);

    }
  }

  const handleDelete = () => {
    SetOpenDel(true)
  }

  const customToolsBar = () => {
    return (
      <Grid container rowSpacing={1} mb={0} paddingBlock={1}>
        <Grid container item lg={12} xs={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
          <Grid item lg={2.5} md={2.5} xs={12}>
            <SearchBar
              value={name}
              setValue={(e) => handleSearch(e)}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={12}>
            <CustomSelect2
              values={filterObject?.status || "-1"}
              onChange={(e) => {
                setPage("1");
                setFilterObject((prevValues) => ({
                  ...prevValues,
                  status: e
                }))
              }}
              data={Helpers.productStatusList}
              placeholder={"All statuses"}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={12}>
            <CustomSelect2
              values={filterObject?.type}
              onChange={(e) => {
                setPage("1");
                setFilterObject((prevValues) => ({
                  ...prevValues,
                  type: e
                }))
              }}
              data={productTypesList}
              placeholder={"All types"}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={12}>
            <CustomSelectMultiple2
              data={categoryListing || []}
              values={filterObject?.category_id || []}
              onChange={(e) => {
                setPage("1");
                setFilterObject((prevValues) => ({
                  ...prevValues,
                  category_id: e
                }))
              }}
              placeholder={"All categories"}
              valueName={"id"}
              labelName={"name"} />
          </Grid>
          <Grid item lg={2} md={2} xs={12}>
            <CustomSelect2
              values={filterObject?.platform}
              onChange={(e) => {
                setPage("1");
                setFilterObject((prevValues) => ({
                  ...prevValues,
                  platform: e
                }))
              }}
              data={platformList}
              placeholder={"Platform"}
            />
          </Grid>
          <Grid item lg={1} md={1} xs={12}>
            <CustomButton
              title={'Clear'}
              press={() => resetFilter()}
              height={32}
              backgroundColor={'transparent'}
              textColor={'#7BB9FA'}
            />
          </Grid>

        </Grid>
        <Grid item lg={12} gap={0.5} xs={12} sx={{ display: 'flex' }} alignItems={'center'}>

          {importable && <CustomButton
            title={<><i className="ri-file-upload-line" style={{ marginRight: 5 }} />Upload Images</>}
            press={() => setPopUpOpen(true)}
            height={32}
            width={200}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />}
          {importable && <CustomButton
            title={<><i className="ri-upload-2-line" style={{ marginRight: 5 }} />Import</>}
            press={() => handleImport(".xlsx,.xls", false)}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />}
          {exportable && <CustomButton
            title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
            press={() => handleExport()}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />}
          {selectedRow !== "" && selectedRow?.length > 0 && <CustomButton
            title={<><i className="ri-file-pdf-2-line" style={{ marginRight: 5 }} />Attach PDF</>}
            press={() => handleBulkAttachPdfOpen()}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />}
          {deletable && selectedRow !== "" && selectedRow?.length > 0 && <CustomButton
            title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
            press={() => handleDelete()}
            height={32}
            borderRadius={15}
            textColor={"white"}
            backgroundColor={"#ED1A3D"}
            borderStyle={"1px solid #ED1A3D"}
          />}
        </Grid>
      </Grid>
    )
  }
  const handleImport = (accept, multiple) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    if (multiple) {
      input.multiple = true;
    }

    input.onchange = async (e) => {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      try {
        if (multiple) {
          // Get existing files
          const existingFiles = Array.from(productImages);
          const newFilesArray = Array.from(files);

          // Check total file limit (maximum 10 files)
          if (existingFiles.length + newFilesArray.length > 10) {
            setNotification({
              open: true,
              msg: `Maximum 10 files allowed. You already have ${existingFiles.length} file(s).`,
              type: "error"
            });
            return;
          }

          // Combine existing and new files
          const combinedFiles = [...existingFiles, ...newFilesArray];

          // Convert combined array back to FileList using DataTransfer
          const dataTransfer = new DataTransfer();
          combinedFiles.forEach(file => dataTransfer.items.add(file));

          // For multiple files, send as FormData with actual files
          const formData = new FormData();
          combinedFiles.forEach((file) => {
            formData.append('files[]', file);
          });

          // Log FormData contents
          for (let pair of formData.entries()) {
          }

          // dispatch(importProduct(formData));
          // setIsLoading(true);
          setProductImages(dataTransfer.files);
        } else {
          // For single file, use base64
          const file = files[0];
          const reader = new FileReader();
          reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // remove data:*/*;base64,

            let payload = {
              file_base64: base64String,
            };

            dispatch(importProduct(payload));
            setIsLoading(true);
          };

          reader.onerror = (error) => {
            console.error("Error reading file:", error);
          };
          reader.readAsDataURL(file); // Read as base64
        }
      } catch (err) {
        console.error("Error processing files:", err);
      }
    };

    input.click();
  };

  const renderHeader = () => {
    return (
      <div className="d-flex justify-content-between align-items-center p-1 pb-2">
        <div className="header">Products</div>
        {
          creatable &&
          <CustomButton
            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Product </>}
            borderStyle={'1px solid #101010'}
            backgroundColor={'#101010'}
            textColor={'white'}
            press={() => setModalOpen(true)}
          />
        }
      </div>
    )
  }

  const productType = [
    { iconName: 'solar:box-bold-duotone', title: "Simple product", subtitle: "A straight forward product with a fixed price and description.", type: "simple", },
    { iconName: 'solar:settings-minimalistic-bold-duotone', title: "Configurable product", subtitle: "A product with customizable variations, that affect the price.", type: "configurate" }
  ]

  const handleSubmitProductPreData = () => {
    if (formValues?.manufacturer && formValues?.model && formValues?.categories.length > 0) {
      if (formValues?.type === "simple") {
        navigate("/simple/add-product")
      } else {
        navigate("/configurable/add-product")
      }
      let data = {
        addType: formValues?.type,
        manufacturer_id: formValues?.manufacturer,
        model_id: formValues?.model,
        categories: formValues?.categories,
      }
      dispatch(preAddData(data))
      setError(false)
    } else {
      setError(true)
      setNotification({
        open: true,
        msg: "Please fill in all required field!",
        type: "warning"
      })
    }

  }

  const handleDeleteFilesTemp = (id) => {
    // Convert FileList to Array, then filter
    const filesArray = Array.from(productImages);
    const filteredFiles = filesArray.filter((_, idx) => id !== idx);

    // Convert back to FileList-like structure (DataTransfer)
    const dataTransfer = new DataTransfer();
    filteredFiles.forEach(file => dataTransfer.items.add(file));

    setProductImages(dataTransfer.files);
  }

  const handleSubmitDelete = () => {
    if (selectedRow?.length > 0) {
      dispatch(deleteBulkProduct({ ids: selectedRow }))

    } else {
      dispatch(deleteProduct({ id: selectedRow }))
    }
  }

  const handleBulkAttachPdfOpen = () => {
    if (!selectedRow || selectedRow.length === 0) {
      setNotification({ open: true, msg: "Please select at least one product.", type: "warning" });
      return;
    }
    setBulkPdfFile(null);
    setBulkPdfError("");
    setBulkPdfModalOpen(true);
  };

  const handleBulkAttachPdfFileSelect = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/pdf";
    input.onchange = (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      if (file.type !== "application/pdf") {
        setBulkPdfError("Only PDF files are allowed.");
        setBulkPdfFile(null);
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setBulkPdfError("File size must not exceed 10 MB.");
        setBulkPdfFile(null);
        return;
      }
      setBulkPdfFile(file);
      setBulkPdfError("");
    };
    input.click();
  };

  const handleBulkAttachPdfSubmit = () => {
    if (!bulkPdfFile) {
      setBulkPdfError("Please select a PDF file.");
      return;
    }
    setBulkPdfError("");
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      // Truncate label to 255 chars to match the DB column limit
      const label = bulkPdfFile.name.substring(0, 255);
      dispatch(bulkAttachPdf({
        ids: selectedRow,
        file: base64,
        label,
      }));
      setIsLoading(true);
    };
    reader.onerror = () => setBulkPdfError("Failed to read file. Please try again.");
    reader.readAsDataURL(bulkPdfFile);
  };

  const handleUploadImages = () => {
    let formData = new FormData();
    if (productImages?.length <= 0 || !productImages) {
      setNotification({
        open: true,
        msg: "Please select at least one attachment to upload.",
        type: "warning"
      });
      return;
    } else {
      Array.from(productImages).forEach((file) => {
        formData.append('upload[]', file);
      });
      dispatch(importProductImage(formData));
    }

  }

  return (
    <React.Fragment>
      <div className="page-content">
        <AppDialog
          open={openDel}
          close={() => SetOpenDel()}
          title={'Delete product'}
          titleIcon={'error'}
          positiveTitle={'Delete product'}
          positivePress={() => handleSubmitDelete()}
          positiveButtonStyle={{ backgroundColor: '#ED1A3D', color: 'white', border: '1px solid #ED1A3D' }}
          negativePress={() => SetOpenDel()}
          negativeTitle={'Cancel'}
          width={'30%'}
        >
          <div className="">
            Are you sure you want to delete this product?
          </div>
        </AppDialog>
        <RejectModal open={rejectModal} setOpen={setRejectMOdal} setFormValues={setApproveRejectValue} values={approveRejectValue} setPositivePress={(e) => (dispatch(approveRejectProduct(approveRejectValue))
          , setRejectMOdal(false))} />
        <ApproveModal open={approveModal} setOpen={setApproveMOdal} values={approveRejectValue} setFormValues={setApproveRejectValue} setPositivePress={(e) => (dispatch(approveRejectProduct(approveRejectValue)))} platformData={platformData} setPlatformData={setPlatformData} />
        <LoadingDialog open={!product?.data || loading} />
        <Container fluid>
          <AppDialog
            open={modalOpen}
            close={() => setModalOpen(false)}
            title={'First, tell us about your listing'}
            negativeTitle={'Cancel'}
            negativePress={() => {
              setModalOpen(false); setError(false);
            }}
            titleIcon={'add'}
            positiveTitle={'Continue'}
            positivePress={() => handleSubmitProductPreData()}
            width={'60%'}
            negativeButtonStyle={{ border: '0px', color: '#505D69' }}
            actionButtonStyle={'justify-content'}
          >
            <Grid container p={2}>
              <Grid item xs={12} pb={2}>
                <Typography sx={{ fontWeight: 600 }}>Product Type</Typography>
                {error && !formValues?.type && <FormHelperText sx={{ color: "red" }}>{"The product type field is required."}</FormHelperText>}

              </Grid>
              <Grid item xs={12} pb={2}>
                <Typography>Choose the type of product you want to add.</Typography>
              </Grid>
              <Grid container spacing={2}>
                {
                  productType.map((x, idx) =>
                    <Grid key={idx} item xs={12} sm={6} pb={4} sx={{ cursor: "pointer", }} onClick={(e) => navigate(x.navigateTo)}>
                      <div style={{ border: formValues?.type === x.type ? '1px solid #ed1a3d' : '1px solid #EDEDED', borderRadius: "4px", minHeight: 99, width: '100%', backgroundColor: formValues?.type === x.type ? "#fef3f5" : "", }}
                        onClick={(e) => setFormValues((prevValues) => ({
                          ...prevValues,
                          type: x.type
                        }))}>
                        <Grid container>
                          <Grid item lg={2} md={2.3} pl={2} pt={2}>
                            <Icon icon={x.iconName} fontSize={50} style={{ color: '#D0D0D0' }} />
                          </Grid>
                          <Grid container className="p-3 px-2" spacing={2} textAlign={"left"}>
                            <Grid item lg={10} md={9.7}>
                              <div className="setting-header pb-2" style={{ fontSize: "18px", paddingLeft: "10px" }}>{x.title}</div>
                              <div className="setting-subheader font-size-16" style={{ paddingLeft: "10px" }}>{x.subtitle}</div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  )
                }
              </Grid>

              <Grid item xs={12} pb={2}>
                <Typography sx={{ fontWeight: 600 }}>Product basic info</Typography>
              </Grid>
              <Grid item xs={12} sm={6} pb={2} pr={2}>
                <CustomSelect
                  title={'Manufacturer'}
                  values={formValues?.manufacturer || '-1'}
                  valueName={"id"}
                  labelName={"name"}
                  placeholder={"All"}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    manufacturer: e
                  }))}
                  data={manufactureListing}
                  error={error && !formValues?.manufacturer && "The manufacturer field is required."}
                />
              </Grid>
              <Grid item xs={12} sm={6} pb={2}>
                <CustomSelect
                  title={'Model'}
                  values={formValues?.model || '-1'}
                  valueName={"id"}
                  labelName={"name"}
                  placeholder={"All"}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    model: e
                  }))}
                  data={modelListing}
                  error={error && !formValues?.model && "The model field is required."}
                />
                {/* <CustomAutocomplete
                  title={'Model'}
                  values={formValues?.model}
                  valueName={"id"}
                  labelName={"name"}
                  placeholder={"All"}
                  onChange={(e, value) => setFormValues((prevValues) => ({
                    ...prevValues,
                    model: value?.id
                  }))}
                  data={modelListing}
                  error={error && !formValues?.model && "The model field is required."}
                /> */}
              </Grid>
              <Grid item xs={12} pb={2}>
                <CustomSelectMultiple
                  title="Categories"
                  values={formValues?.categories || '-1'}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    categories: e
                  }))}
                  valueName={"id"}
                  labelName={"slug"}
                  placeholder={'Select one or more'}
                  data={categoryListing}
                  error={error && formValues?.categories.length <= 0 && "The categories field is required."}
                />
              </Grid>
            </Grid>
          </AppDialog>
          <AppDialog
            open={popUpOpen}
            close={() => { setPopUpOpen(false); setProductImages([]); }}
            title={'Upload Images'}
            negativeTitle={'Cancel'}
            negativePress={() => {
              setPopUpOpen(false); setProductImages([]);
            }}
            titleIcon={'add'}
            positiveTitle={"Submit"}
            positivePress={() => handleUploadImages()}
            width={'60%'}
            negativeButtonStyle={{ border: '0px', color: '#505D69' }}
            actionButtonStyle={'justify-content'}
          >
            {/* <i class="ri-folder-zip-fill"></i> */}
            {/* <Grid container p={2} spacing={2} onClick={() => handleImport(".zip,.jpg,.jpeg,.png, .webp", true,)}> */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <b>You can upload individual images or ZIP files.</b><br />
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12} sm={6}>
                    <b>Image Upload Requirements:</b><br />
                    <span>• Maximum <b>5 MB per image</b></span><br />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <b>ZIP File Requirements:</b><br />
                    <span>• Total combined size of <b>all ZIP</b> files must not exceed 50 MB</span><br />
                    <span>• Any non-image files inside the ZIP will be <b>ignored automatically</b></span><br />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} >
                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Attachments ({(productImages && productImages.length) || 0}/10)</FormLabel>

                <Grid container spacing={2}>
                  <Tooltip title="Click to add attachments">
                    <Grid item auto>
                      <div className="empty-image-container" style={{ cursor: 'pointer' }} onClick={() => handleImport(".zip,.jpg,.jpeg,.png, .webp", true,)}>
                        <i className="ri-add-large-line" style={{ color: '#D0D0D0', fontSize: 40 }} /></div>
                    </Grid>
                  </Tooltip>

                  {
                    productImages.length > 0 ? Array.from(productImages).map((file, idx) => {
                      const isZip = file.type === 'application/zip' || file.type === 'application/x-zip-compressed' || file.name.endsWith('.zip');
                      const imageUrl = !isZip ? URL.createObjectURL(file) : null;

                      return (
                        <Grid item auto>
                          <Card
                            style={{ border: "none" }}
                            className="mt-1 mb-0 shadow-none dz-processing dz-image-preview dz-success dz-complete"
                            key={idx + "-file"}
                          >
                            {/* <Stack flexDirection={"row"} justifyContent={"space-between"}> */}
                            <div className="p-0">
                              {isZip ?
                                <Tooltip title={file.name}>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '75px', width: '75px' }}>
                                    <i className="ri-folder-zip-fill" style={{ fontSize: '40px', color: '#FFA500' }} />
                                    <span style={{ fontSize: '10px', textAlign: 'center', wordBreak: 'break-word', marginTop: "2px", lineHeight: '1.2', maxWidth: '75px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{file.name}</span>
                                  </div>
                                </Tooltip> :
                                <Tooltip title={file.name}>
                                  <img
                                    data-dz-thumbnail=""
                                    style={{ objectFit: "contain", height: '75px', width: '75px' }}
                                    className="avatar-sm rounded bg-light"
                                    alt={` ${imageUrl || "product details"}`}
                                    src={`${imageUrl}`}
                                  />
                                </Tooltip>
                              }
                              <span>
                                <i style={{ color: "red", cursor: "pointer", position: "absolute", top: "-15px", right: "-10px", }} onClick={(e) => handleDeleteFilesTemp(idx)} className="ri-close-circle-fill font-size-20"></i>
                              </span>
                            </div>
                            {/* </Stack> */}
                          </Card>
                        </Grid>

                      );
                    }) : null
                  }
                </Grid>
              </Grid>

            </Grid>
            {/* </Grid> */}
          </AppDialog>
          <AppDialog
            open={bulkPdfModalOpen}
            close={() => setBulkPdfModalOpen(false)}
            title={`Attach PDF to ${selectedRow?.length || 0} product(s)`}
            negativeTitle={'Cancel'}
            negativePress={() => setBulkPdfModalOpen(false)}
            titleIcon={'add'}
            positiveTitle={"Attach"}
            positivePress={() => handleBulkAttachPdfSubmit()}
            width={'50%'}
            negativeButtonStyle={{ border: '0px', color: '#505D69' }}
            actionButtonStyle={'justify-content'}
          >
            <Grid container spacing={2} p={2}>
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  The same PDF will be saved as an <b>independent copy</b> for each selected product.
                  Updating one product's attachment later will not affect the others.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>PDF File</FormLabel>
                <div
                  className="mt-1"
                  style={{
                    border: '1px dashed #D0D0D0',
                    borderRadius: 8,
                    padding: '16px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    backgroundColor: '#FAFAFA',
                  }}
                  onClick={handleBulkAttachPdfFileSelect}
                >
                  {bulkPdfFile ? (
                    <Stack flexDirection="row" alignItems="center" justifyContent="center" spacing={1}>
                      <i className="ri-file-pdf-2-line" style={{ fontSize: 28, color: '#ED1A3D' }} />
                      <span style={{ fontSize: 14 }}>{bulkPdfFile.name}</span>
                      <i className="ri-close-circle-fill" style={{ color: '#D0D0D0', cursor: 'pointer', fontSize: 18 }}
                        onClick={(e) => { e.stopPropagation(); setBulkPdfFile(null); }} />
                    </Stack>
                  ) : (
                    <Stack flexDirection="column" alignItems="center" spacing={0.5}>
                      <i className="ri-upload-cloud-2-line" style={{ fontSize: 32, color: '#D0D0D0' }} />
                      <span style={{ fontSize: 13, color: '#888' }}>Click to select a PDF file</span>
                      <span style={{ fontSize: 11, color: '#aaa' }}>PDF only. 10 MB Max</span>
                    </Stack>
                  )}
                </div>
                {bulkPdfError && <FormHelperText sx={{ color: 'red' }}>{bulkPdfError}</FormHelperText>}
              </Grid>
            </Grid>
          </AppDialog>
          <Notification notification={notification} setNotification={setNotification} />
          <DeleteModal setContent={setContent} content={content} />
          {renderHeader()}
          {customToolsBar()}
          <Table
            header={header}
            data={product && product?.data}
            getLengthPage={getLengthPage}
            pageSize={length}
            totalPage={product && product?.last_page}
            customToolsBar={true}
            sort={sort}
            setCheckedAll={setCheckedAll}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            checkedAll={checkedAll}
          />
          <TablePageControl
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={product && product?.last_page}
          />
          <ProductFilterContent
            open={open}
            close={() => SetOpen(false)}
            formValue={filterObject}
            onChange={setFilterObject}
            raceList={[]}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

function mapStateToProps({ Product, Login, Category, General, Model }) {
  return {
    product: Product.productListing,
    productds: Product,
    delProduct: Product.delProduct,
    userData: Login?.verifyAdmin?.user?.data,
    delProductArry: Product?.deleteProduct,
    delBulkProductArry: Product?.deleteBulkProduct,
    exportExcel: Product.exportProduct,
    importExcelData: Product.importProduct,
    importImageData: Product.importProductImage,
    bulkAttachPdfState: Product.bulkAttachPdf,
    approveRejectProductState: Product.approveRejectProductState,
    categoryListing: General.categories,
    manufactureListing: General.manufacturers,
    modelListing: General.models,
    userPermission: Login.permissionArry,
  };
}



export default connect(mapStateToProps)(Products);
